import { render, staticRenderFns } from "./ClaimsValueAndCountChart.vue?vue&type=template&id=5847c734&scoped=true"
import script from "./ClaimsValueAndCountChart.vue?vue&type=script&lang=js"
export * from "./ClaimsValueAndCountChart.vue?vue&type=script&lang=js"
import style0 from "./ClaimsValueAndCountChart.vue?vue&type=style&index=0&id=5847c734&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5847c734",
  null
  
)

export default component.exports